//Core
import React from "react";

//Style
import "./style.scss";

//Components
import HeaderLayout from "./HeaderLayout";
import Description from "../Description";
import OrderButton from "../OrderButton"

//helpers
console.log(
  `%c TASCOMBANK`,
  "background: #333366; color: white; font-size: 15px; padding: 3px 40%;"
)

const Header = () => {
  return (
      <HeaderLayout>
        <div className="HeaderContainer">
          <h1 className="main_title">
            до 9,5% РІЧНИХ У ГРИВНІ!
            <br />
            <span className="sub_title">&nbsp;</span>
          </h1>
        </div>
      </HeaderLayout>
  )
}

export default Header
